import type { ReactNode } from "react";

import styles from "./PageHeader.module.css";

type PageHeaderProps = {
  // Sits right beside the title: a chip that qualifies it ("Viewing Noaa's list").
  beside?: ReactNode;
  // Page-wide controls, at the right-hand end of the title row.
  actions?: ReactNode;
  description?: ReactNode;
} & (
  | { title: ReactNode; heading?: never }
  // A page whose title is edited in place brings its own h1, styled with
  // pageTitleClassName.
  | { heading: ReactNode; title?: never }
);

// Every top-level page's title, in one place and one size, so a page's name never
// moves as the reader goes between them. Tabs and content follow it.
export const PageHeader = ({ title, heading, beside, actions, description }: PageHeaderProps) => (
  <header className={styles.header}>
    <div className={styles.row}>
      {heading ?? <h1 className={styles.title}>{title}</h1>}
      {beside}
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </header>
);
